/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Status_Export_FailedInputs */

const en_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export failed`)
};

const fr_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation echouee`)
};

const de_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export fehlgeschlagen`)
};

const it_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione fallita`)
};

const ru_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт не удался`)
};

const es_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación fallida`)
};

const zh_cn2_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出失败`)
};

const ja_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートに失敗しました`)
};

const hi_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात विफल रहा`)
};

const pt_pt2_video_export_status_export_failed = /** @type {(inputs: Video_Export_Status_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação falhou`)
};

/**
* | output |
* | --- |
* | "Export failed" |
*
* @param {Video_Export_Status_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_export_failed = /** @type {((inputs?: Video_Export_Status_Export_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_Export_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_status_export_failed(inputs)
	if (locale === "de") return de_video_export_status_export_failed(inputs)
	if (locale === "it") return it_video_export_status_export_failed(inputs)
	if (locale === "ru") return ru_video_export_status_export_failed(inputs)
	if (locale === "es") return es_video_export_status_export_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_status_export_failed(inputs)
	if (locale === "ja") return ja_video_export_status_export_failed(inputs)
	if (locale === "hi") return hi_video_export_status_export_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_status_export_failed(inputs)
	return en_video_export_status_export_failed(inputs)
});